import type { OnboardingVideo } from "./videos";

type OnboardingVideoCardProps = {
  video: OnboardingVideo;
};

export const OnboardingVideoCard = ({ video }: OnboardingVideoCardProps) => (
  <div className="relative h-full flex-1 overflow-hidden rounded-xl bg-neutral-200">
    <iframe
      src={video.url}
      title={video.title}
      className="h-full w-full border-0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
    <div className="pointer-events-none absolute inset-0 flex flex-col justify-end gap-0.5 bg-gradient-to-t from-black/60 to-transparent p-3">
      <span className="text-sm font-semibold text-white">{video.title}</span>
      <span className="text-xs text-white/80">{video.duration}</span>
    </div>
  </div>
);

export default OnboardingVideoCard;
